import React from "react";
import axios from "axios";
import Cookies from "js-cookie";

const Logout = () => {

  const logout = async () => {
    try {
      await axios.get(`${process.env.REACT_APP_API_URL}/api/user/logout`, {
        withCredentials: true,
      });
      window.location = "/";
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <span className="zoneLogoUtilisateur">
      <img
        src="/img/logo_utilisateur.png"
        alt="logo utilisateur"
        title="Se déconnecter"
      />
      <div className="spanHover">
        <span onClick={logout}>Se déconnecter</span>
        <span>
          <a href="/Profil" alt="/">
            Accéder au profil
          </a>
        </span>
      </div>
    </span>
  );
};

export default Logout;
